/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import {
    makeStyles,
    Drawer,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse
} from '@material-ui/core'
//icones
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import PersonIcon from '@material-ui/icons/Person';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ListIcon from '@material-ui/icons/List';

import Constants from '../../utils/Constants'
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
    drawer: {
        width: Constants.sideBarWidth,
    },
    drawerPaper_desktop: {
        width: Constants.sideBarWidth,
        marginTop: '64px'
    },
    drawerPaper_mobile: {
        width: Constants.sideBarWidth
    },
    nested: {
        marginLeft: '10px'
    }
})

export default function Sidebar(props) {
    const history = useHistory()
    const classes = useStyles()
    const [openOptionsEmployee, setOpenOptionsEmployee] = useState(false)
    const [openOptionsPatient, setOpenOptionsPatient] = useState(false)

    const handleClickEmployeeItem = () => {
        setOpenOptionsEmployee(openOptionsEmployee => !openOptionsEmployee)
    }

    const handleClickPatientItem = () => {
        setOpenOptionsPatient(openOptionsPatient => !openOptionsPatient)
    }

    return (
        <Drawer
            className={classes.drawer}
            open={props.mobile ? props.open : true}
            variant={props.mobile ? "temporary" : "permanent"}
            classes={props.mobile ? ({
                paper: classes.drawerPaper_mobile,
            }) : { paper: classes.drawerPaper_desktop }}
        >
            <div>
                {props.mobile ? (
                    <Button onClick={props.closeSideBar}>Fechar</Button>
                ) : null}
                <List>
                    <ListItem button onClick={handleClickEmployeeItem}>
                        <ListItemIcon>
                            <LocalHospitalIcon />
                        </ListItemIcon>
                        <ListItemText primary="Profissonais de saúde" />
                        {openOptionsEmployee ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openOptionsEmployee} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button 
                                className={classes.nested}
                                onClick={() => {
                                    history.push('/professional/add')
                                    props.closeSideBar()
                                }}
                            >
                                <ListItemIcon>
                                    <PersonAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="Adicionar" />
                            </ListItem>
                            <ListItem button 
                                className={classes.nested}
                                onClick={() => {
                                    history.push('/professional')
                                    props.closeSideBar()
                                }
                                }
                            >
                                <ListItemIcon>
                                    <ListIcon />
                                </ListItemIcon>
                                <ListItemText primary="Gerenciar" />
                            </ListItem>
                        </List>
                    </Collapse>
                    <ListItem button onClick={handleClickPatientItem}>
                        <ListItemIcon>
                            <PersonIcon />
                        </ListItemIcon>
                        <ListItemText primary="Pacientes" />
                        {openOptionsPatient ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openOptionsPatient} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button 
                                className={classes.nested}
                                onClick={() => {
                                    history.push('/patients/add')
                                    props.closeSideBar()
                                }}
                            >
                                <ListItemIcon>
                                    <PersonAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="Adicionar" />
                            </ListItem>
                            <ListItem button 
                                className={classes.nested}
                                onClick={() => {
                                    history.push('/patients')
                                    props.closeSideBar()
                                }
                                }
                            >
                                <ListItemIcon>
                                    <ListIcon />
                                </ListItemIcon>
                                <ListItemText primary="Gerenciar" />
                            </ListItem>
                        </List>
                    </Collapse>
                </List>
            </div>
        </Drawer>
    )
}
